import { render, staticRenderFns } from "./IconNavigationCollapse.vue?vue&type=template&id=1f9f01e6"
import script from "./IconNavigationCollapse.vue?vue&type=script&lang=js"
export * from "./IconNavigationCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports